import User from './models/User'

export default {

  namespaced: true,

  state: {
    user: new User
  },

  mutations: {
    ...User.commonMutations()
  },

  actions: {

  },

  getters: {

  }

}
